import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

import { selectSettings } from 'src/app/stores/settings';
import { GANDALF_HOST } from 'src/environments/runtime';

import { ISensor } from '../../interfaces/ISensor';
import { FrodoSettings } from '../../services/appconfig/settings.model';
import { DeviceService } from '../../services/device/device.service';
import { SocketService } from '../../services/socket/socket.service';
import { FRICTIONLESS_FLOW, PRESENCE, VIEW_TYPES } from '../../utils/constants';

@Component({
  selector: 'frodo-help-center',
  templateUrl: './help-center.component.html',
  styleUrls: ['./help-center.component.scss'],
})
export class HelpCenterComponent implements OnInit, OnDestroy {
  logo: string;
  homeButton: string;
  state: RouterStateSnapshot;
  subscription: Subscription = new Subscription();
  appUrl: string;
  vision10kFlow: boolean;
  positions: string[] = [];
  enable: boolean;
  frodoSettings: FrodoSettings;
  deviceSn: string;
  validatePresenceSensor = false;

  constructor(
    private store: Store,
    private router: Router,
    private socketService: SocketService,
    private deviceService: DeviceService
  ) {
    this.state = router.routerState.snapshot;
    this.socketService.setSocketHost(GANDALF_HOST);
    this.subscription.add(
      this.deviceService.getSerialNum.subscribe((serialNum) => {
        this.deviceSn = serialNum;
      })
    );
  }

  ngOnInit(): void {
    this.subscription.add(
      this.store.select(selectSettings).subscribe((settings) => {
        this.vision10kFlow = settings.defaultSettings.vision10kFlow;
        this.frodoSettings = settings.apps.frodo;
        this.enable = this.frodoSettings.homescreen.enable;
        this.validatePresenceSensor = settings.device.validatePresenceSensor;
        this.logo = this.frodoSettings.style.logo;
        this.homeButton = this.frodoSettings.style.icons.homeButton;
      })
    );

    this.appUrl = this.state.url.split('/')[1];
    if (
      this.validatePresenceSensor &&
      this.vision10kFlow &&
      this.appUrl === VIEW_TYPES.REAR_LOADING
    ) {
      this.checkForPresence();
    }
  }

  checkForPresence() {
    this.socketService.listen(PRESENCE, (data) => {
      const parsedData: ISensor = JSON.parse(data.msg.body);
      const changes = parsedData[this.deviceSn];
      if (changes) {
        const presence = changes.eventType === 'FILL';
        const positionIndex = this.positions.findIndex((position) => position === changes.position);
        if (positionIndex !== -1) {
          this.positions.splice(positionIndex, 1);
        } else if (presence) {
          this.positions.push(changes.position);
          this.navigate();
        }
      }
    });
  }

  navigate(): void {
    if (this.enable) {
      const defaultScreen = this.frodoSettings.homescreen.defaultScreen;
      switch (defaultScreen) {
        case 'order-id':
        case 'scan':
          this.router.navigate([
            'rear-loading/create-order',
            {
              type: defaultScreen,
              flow: FRICTIONLESS_FLOW,
              positions: JSON.stringify(this.positions),
            },
          ]);
          break;
        case 'mobile':
          this.router.navigate([
            'rear-loading/create-order-by-phone',
            {
              type: defaultScreen,
              flow: FRICTIONLESS_FLOW,
              positions: JSON.stringify(this.positions),
            },
          ]);
          break;
        case 'delivery-list':
          this.router.navigate([
            'rear-loading/delivery-list',
            {
              flow: FRICTIONLESS_FLOW,
            },
          ]);
          break;
      }
    } else {
      this.router.navigate(['rear-loading/home', { positions: JSON.stringify(this.positions) }]);
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    if (this.socketService && this.socketService.socket) {
      this.socketService.socket.off(PRESENCE);
    }
  }
}
